export default "__VITE_ASSET__7QHsRyAy__"